<template>
  <div class="product-template container">
    <transition name="fade-out-left" mode="out-in" appear>
      <div v-if="isLoading" key="loading">
        <placeholder-rect height="200px" class="mb-1" />
      </div>

      <div v-else-if="selectedProduct" key="checkout">
        <checkout
          :product="selectedProduct"
          @success="handlePurchaseSuccess"
          v-on="products.length > 1 ? { back: handleBack } : {}"
        />
      </div>

      <div v-else key="checkout-products">
        <checkout-products
          :products="products"
          class="px-2"
          @select="handleSelectProduct"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import {
  STAGES,
  CALLBACK_PARAMS,
  SETUP_INTENT_PRODUCT_ID
} from "@/lib/checkout-utils"

import PlaceholderRect from "@/components/PlaceholderRect"
import Checkout from "@/components/checkout/Checkout"
import CheckoutProducts from "@/components/checkout/CheckoutProducts"

export default {
  components: {
    PlaceholderRect,
    Checkout,
    CheckoutProducts
  },

  props: {
    productIds: { type: Array, default: () => [] }
  },

  data() {
    return {
      selectedProduct: null,
      products: [],
      isLoading: false
    }
  },

  computed: {
    ...mapGetters("auth", ["hasCheckedAuthentication"]),

    isMultipleProducts() {
      return this.products.length > 1
    }
  },

  watch: {
    hasCheckedAuthentication: {
      immediate: true,
      handler: function(value) {
        if (value) {
          this.fetchAndShowProducts()
        }
      }
    }
  },

  methods: {
    ...mapActions("products", ["fetchMultipleProducts"]),

    fetchAndShowProducts() {
      this.isLoading = true

      this.fetchMultipleProducts(this.productIds)
        .then(products => {
          this.products = products

          if (this.$route.query[CALLBACK_PARAMS.PRODUCT_ID]) {
            this.selectedProduct = this.products.find(
              p => p.id == this.$route.query[CALLBACK_PARAMS.PRODUCT_ID]
            )
          } else if (this.$route.query[CALLBACK_PARAMS.SETUP_INTENT]) {
            this.selectedProduct = { id: SETUP_INTENT_PRODUCT_ID }
          } else if (!this.isMultipleProducts) {
            this.selectedProduct = this.products[0]
            this.$router.push(STAGES.PAY)
          }

          if (!this.selectedProduct) this.$router.removeHash()
        })
        .catch(() => {
          this.products = []
          this.selectedProduct = null
          this.$router.removeHash()
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    async handlePurchaseSuccess() {
      this.$router.push(STAGES.SUCCESS)
    },

    handleSelectProduct(product) {
      this.selectedProduct = product
      this.$router.push(STAGES.PAY)
    },

    handleBack() {
      this.selectedProduct = null
      this.$router.removeHash()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.product-template {
  padding-top: calc(env(safe-area-inset-top) + $size--4);
}
</style>
